import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useDesignStore from '../../store/designStore';
import useUIStore from '../../store/uiStore';
import ScrollX from '../../components/ScrollX';

const statusColors = {
  draft: 'bg-gray-200 text-gray-800',
  pending_review: 'bg-amber-100 text-amber-800',
  engineer_approved: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
};

const DesignCalculationsListPage = () => {
  const { calculations, isLoading, error, fetchCalculations } = useDesignStore();
  const showToast = useUIStore((s) => s.showToast);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    fetchCalculations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) showToast(error, 'error');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    fetchCalculations(value ? { status: value } : {});
  };

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h1 className="text-2xl font-bold text-white">Saved Design Calculations</h1>
          <div className="flex items-center gap-3">
            <select
              value={statusFilter}
              onChange={handleFilterChange}
              className="border border-gray-300 rounded px-3 py-2 text-sm"
            >
              <option value="">All statuses</option>
              <option value="draft">Draft</option>
              <option value="pending_review">Pending Review</option>
              <option value="engineer_approved">Engineer Approved</option>
              <option value="rejected">Rejected</option>
            </select>
            <Link
              to="/design"
              className="bg-komal-blue hover:bg-komal-blue-dark text-white text-sm font-semibold px-4 py-2 rounded"
            >
              + New Calculation
            </Link>
          </div>
        </div>

        <div className="glass-card">
          {isLoading ? (
            <p className="text-gray-500 text-sm p-5">Loading...</p>
          ) : calculations.length === 0 ? (
            <p className="text-gray-500 text-sm p-5">No calculations saved yet.</p>
          ) : (
            <ScrollX>
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b border-gray-100">
                  <th className="px-5 py-2 font-medium">Type</th>
                  <th className="px-5 py-2 font-medium">Project</th>
                  <th className="px-5 py-2 font-medium">Created By</th>
                  <th className="px-5 py-2 font-medium">Status</th>
                  <th className="px-5 py-2 font-medium">Saved</th>
                  <th className="px-5 py-2 font-medium"></th>
                </tr>
              </thead>
              <tbody>
                {calculations.map((c) => (
                  <tr key={c.id} className="border-b border-gray-50 last:border-0">
                    <td className="px-5 py-3 capitalize">{c.calculator_type.replace(/_/g, ' ')}</td>
                    <td className="px-5 py-3">{c.project_name || '—'}</td>
                    <td className="px-5 py-3">{c.created_by_name || '—'}</td>
                    <td className="px-5 py-3">
                      <span className={`px-2 py-1 rounded text-xs font-semibold capitalize ${statusColors[c.status]}`}>
                        {c.status.replace(/_/g, ' ')}
                      </span>
                    </td>
                    <td className="px-5 py-3 text-xs text-gray-500">
                      {c.created_at ? new Date(c.created_at).toLocaleDateString() : '—'}
                    </td>
                    <td className="px-5 py-3">
                      <Link
                        to={`/design/calculations/${c.id}`}
                        className="text-xs font-semibold text-komal-blue hover:underline"
                      >
                        {c.status === 'draft' || c.status === 'pending_review' ? 'View & Review →' : 'View →'}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </ScrollX>
          )}
        </div>
      </div>
    </div>
  );
};

export default DesignCalculationsListPage;
